import React from 'react'
import OrderingNotEnabledPage from '../OrderingNotEnabledPage'
import Edit from './Edit'
import useTimeBasedMenuVisibility from './useTimeBasedMenuVisibility'
import View from './View'

type Props = { showTitle?: boolean }

const TimeBasedMenuVisibility = ({ showTitle = true }: Props) => {
  const {
    hasCapability,
    orderingEnabled,
    setting,
    isLoading,
    isError,
    isEditing,
    isSubmitting,
    startEditing,
    stopEditing,
    publish,
  } = useTimeBasedMenuVisibility()

  // Render nothing rather than redirect like RevenueCenters does: this also
  // mounts as one tab among many, where a redirect would pull the merchant off
  // the whole settings page.
  if (!hasCapability) {
    return null
  }

  if (!orderingEnabled) {
    return <OrderingNotEnabledPage />
  }

  if (isEditing) {
    return (
      <Edit
        setting={setting}
        isSubmitting={isSubmitting}
        onPublish={publish}
        onExit={stopEditing}
      />
    )
  }

  return (
    <View
      setting={setting}
      isLoading={isLoading}
      isError={isError}
      showTitle={showTitle}
      onEdit={startEditing}
    />
  )
}

export default TimeBasedMenuVisibility
